import { useOnline } from '../hooks/use-online';

export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-50 bg-amber-600/95 px-3 py-1.5 text-center text-xs font-medium text-white shadow-md"
    >
      Offline – zwischengespeicherte Daten werden angezeigt
    </div>
  );
}
